import React from 'react';
import c from 'classnames';
import s from './SimpleTooltipText.scss';
const SimpleTooltipText = ({ children, className })=>{
    return /*#__PURE__*/ React.createElement("span", {
        className: c(s['root'], className)
    }, children);
};
SimpleTooltipText.displayName = 'SimpleTooltipText';
export default SimpleTooltipText;

//# sourceMappingURL=SimpleTooltipText.js.map